export default __webpack_public_path__ + "static/media/BuildAnimals-Wide.f1878b47.jpg";